import React, { FC, useCallback, useState } from 'react';

import { LayoutChangeEvent, View } from 'react-native';

import { useAppTakeoverPdp } from 'components/app-takeover/use-app-takeover';
import { DeliveryFeesStripe } from 'components/delivery-fees-stripe';
import { FullWidthAutoHeightImage } from 'components/picture';
import { ProductPriceCalories } from 'pages/menu/components/product-detail/product-price-calories';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { useScrollResetOnMount } from 'state/scroll/hooks/use-scroll-reset-on-mount';
import { primitive } from 'styles/constants/primitives';
import { TraceName, stopTrace } from 'utils/performance/trace';

import { ProductWizardStep } from '../../product-wizard/types';
import { useProductWizardFlow } from '../../product-wizard/use-product-wizard-flow';

import { CurvedBackground } from './curved-bg';
import {
  ProductImage,
  ProductInformationContainer,
  ProductOverviewContainer,
  ProductTitle,
} from './styled';

interface ProductOverviewProps {
  productTitle?: string;
}

// NEW - 1M
export const ProductOverview: FC<ProductOverviewProps> = props => {
  const { selectedProductImage } = useProductWizardContext();
  const { currentFlowStep, id } = useProductWizardFlow();
  const [bgHeight, setBgHeight] = useState(0);
  const takeoverPdp = useAppTakeoverPdp(id);

  useScrollResetOnMount();

  const onImageDisplay = useCallback(() => {
    stopTrace(TraceName.MENU_PDP_LOAD, { menuItemId: id, isOneMenu: 'false' });
  }, [id]);

  return (
    <ProductOverviewContainer withSpacing={!!props.productTitle}>
      {props.productTitle ? (
        <ProductTitle fontFamily={takeoverPdp?.fontFamily}>{props.productTitle}</ProductTitle>
      ) : (
        <>
          {takeoverPdp.isTakeoverActive ? (
            <>
              <FullWidthAutoHeightImage
                source={takeoverPdp?.overviewBottomImage}
                style={{ position: 'absolute', top: takeoverPdp?.overviewBottomImageOffset }}
              />
              <FullWidthAutoHeightImage
                source={takeoverPdp?.overviewTopImage}
                style={{ position: 'absolute' }}
              />
            </>
          ) : (
            <View
              style={{
                position: 'absolute',
                height: bgHeight,
                width: '100%',
              }}
            >
              <CurvedBackground
                height={bgHeight}
                curveColor={primitive.$white}
                backgroundColor={primitive.bk.$mayoEggWhite}
              />
            </View>
          )}

          <ProductImage
            image={selectedProductImage}
            alt={selectedProductImage.locale?.imageDescription ?? ''}
            onDisplay={onImageDisplay}
            onLayout={({ nativeEvent }: LayoutChangeEvent) => {
              const { height } = nativeEvent.layout;
              const bgHeight = height - height * 0.4;
              setBgHeight(bgHeight);
            }}
          />
        </>
      )}

      <ProductInformationContainer>
        <ProductPriceCalories />
        {currentFlowStep?.step === ProductWizardStep.ProductHome && <DeliveryFeesStripe />}
      </ProductInformationContainer>
    </ProductOverviewContainer>
  );
};
